module.exports = __webpack_public_path__ + "static/media/slash.cdbdf18f.svg";